if (!customElements.get('vbb-reactive-tag-login')) {
  customElements.define('vbb-reactive-tag-login', class ReactiveTagLogin extends HTMLElement {
    constructor() {
      super();
      this.variantDetails = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    handleVariantChange(event) {
      const variantTags = this.variantDetails.variants[event.detail.variantId];
      const customerTags = this.variantDetails.customerTags;

      if (!variantTags) {
        // This variant has no tag gate, show as accessible
        this.classList.add('hidden');
        return;
      }

      // Check if customer has any of the required tags for this variant
      const hasAccess = variantTags.some(requiredTag =>
        customerTags.includes(requiredTag)
      );

      if (hasAccess) {
        this.classList.add('hidden');
      } else {
        this.classList.remove('hidden');
      }
    }


    connectedCallback() {
      if (!this.productForm) {
        this.productForm = this.closest('vbb-product-form-reactive');
        this.productForm.addEventListener('variant:changed', this.handleVariantChange);
      }
    }
  });
}
